var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 12.13a1.25 1.25 0 0 0 -1.16-.78h-2.03v-7.35a1.76 1.76 0 0 0 -1.76-1.76h-8.05a1.76 1.76 0 0 0 -1.81 1.76v7.34h-2.07a1.26 1.26 0 0 0 -.89 2.15l7.88 7.88a1.26 1.26 0 0 0 1.78 0l7.88-7.88a1.25 1.25 0 0 0 .23-1.36zm-10.75-4.33a1 1 0 1 1 -1 1 1 1 0 0 1 1-1zm.34 6.2a.77.77 0 0 1 -.59.28.76.76 0 0 1 -.59-1.22l4-5a.75.75 0 0 1 1.06-.06.77.77 0 0 1 .12 1zm3.16.28a1 1 0 1 1 1-1 1 1 0 0 1 -1 1.02z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPrice);
export default __webpack_public_path__ + "static/media/low-price.193ae3a123e5ec830bd3b15b66025553.svg";
export { ForwardRef as ReactComponent };